var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _line3, _line4, _path16, _line5, _line6, _path17, _path18, _rect7, _rect8, _rect9, _path19, _rect10, _rect11, _rect12, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.382 217.985L340.869 132.04C340.796 130.847 341.562 128.638 345.214 129.354L516.95 129.354C518.716 128.981 522.914 129.534 525.578 134.726L569.492 195.156C570.844 197.021 574.367 200.751 577.638 200.751L634.643 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.155 218.209L295.644 132.183C295.731 130.988 294.989 128.777 291.326 129.494L119.453 129.494C117.69 129.121 113.483 129.674 110.757 134.872L66.1215 195.373C64.7468 197.24 61.1789 200.975 57.9051 200.975L0.854912 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 316.911L294.56 324.073C294.635 325.117 294.158 327.206 291.656 327.206L221.663 327.206C221.022 327.206 219.265 325.953 217.369 320.94C216.953 319.838 214.995 315.017 212.016 307.735M0.737039 221.79L20.821 221.79M138.139 189.784L138.118 193.365L138.16 185.979M138.139 189.784L149.504 189.784M138.139 189.784L126.774 189.784M149.504 189.784L160.869 189.784C162.985 189.784 164.463 192.172 164.937 193.365C175.141 218.091 191.762 258.404 203.57 287.144M149.504 189.784L149.483 193.365L149.525 185.979M126.774 189.784L115.409 189.784C113.967 189.635 110.404 190.142 107.692 193.365L97.1586 205.787M126.774 189.784L126.754 193.365L126.796 185.979M97.1586 205.787L86.6252 218.209C85.4158 219.402 82.6121 221.79 81.0727 221.79L60.9888 221.79M97.1586 205.787L107.621 205.787L86.6957 205.787M40.9049 221.79L40.8782 226.49M40.9049 221.79L60.9888 221.79M40.9049 221.79L20.821 221.79M60.9888 221.79L60.9621 226.49M20.821 221.79L20.7943 226.49M212.016 307.735L223.698 307.735M212.016 307.735C210.775 304.7 209.356 301.238 207.797 297.439M207.797 297.439L223.756 297.439M207.797 297.439C206.48 294.229 205.064 290.779 203.57 287.144M203.57 287.144L223.815 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.829 316.911L339.788 324.073C339.702 325.117 340.155 327.206 342.656 327.206L412.65 327.206C413.291 327.206 415.062 325.953 417.015 320.94C417.444 319.838 419.456 315.017 422.518 307.735M634.772 221.79L614.689 221.79M497.734 189.784L497.714 193.365L497.756 185.979M497.734 189.784L486.369 189.784M497.734 189.784L509.099 189.784M486.369 189.784L475.004 189.784C472.888 189.784 471.383 192.172 470.895 193.365C460.41 218.091 443.332 258.404 431.197 287.144M486.369 189.784L486.349 193.365L486.391 185.979M509.099 189.784L520.464 189.784C521.908 189.635 525.465 190.142 528.14 193.365L538.533 205.787M509.099 189.784L509.079 193.365L509.12 185.979M538.533 205.787L548.925 218.209C550.121 219.402 552.897 221.79 554.437 221.79L574.521 221.79M538.533 205.787L528.07 205.787L548.995 205.787M594.605 221.79L594.578 226.49M594.605 221.79L574.521 221.79M594.605 221.79L614.689 221.79M574.521 221.79L574.494 226.49M614.689 221.79L614.662 226.49M422.518 307.735L410.836 307.735M422.518 307.735C423.794 304.7 425.252 301.238 426.853 297.439M426.853 297.439L410.894 297.439M426.853 297.439C428.207 294.229 429.662 290.779 431.197 287.144M431.197 287.144L410.953 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.345 201.87L319.351 24.6092C319.355 23.8631 319.845 22.371 321.769 22.371L524.051 22.371C526.296 22.4456 530.789 21.8339 530.807 18.79C530.824 15.7461 530.87 7.6739 530.89 4.01826C530.815 3.12301 531.242 1.33249 533.551 1.33249L625.502 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.837 201.87L318.34 113.24L318.843 24.6092C318.847 23.8631 318.376 22.371 316.454 22.371L114.479 22.371C112.237 22.4456 115.849 21.6537 115.867 18.6099C115.884 15.566 115.93 7.49375 115.95 3.83812C116.036 2.94286 107.538 1.33249 105.232 1.33249L11.0155 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.594 337.726L317.548 345.783C317.377 347.723 318.092 351.602 322.326 351.602L497.188 351.602C498.47 351.751 501.955 350.886 505.637 346.231L563.291 274.162C564.341 272.894 566.873 270.357 568.604 270.357L634.268 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.592 337.726L316.546 345.783C316.695 347.723 315.936 351.602 311.703 351.602L136.84 351.602C135.556 351.751 132.082 350.886 128.452 346.231L71.616 274.162C70.5809 272.894 68.0778 270.357 66.346 270.357L0.68242 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.76 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.34863 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 11.1352,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 293.366 249.21)",
    fill: "url(#paint0_linear_439_972)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 20.8785,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 293.301 264.521)",
    fill: "url(#paint1_linear_439_972)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 19.4866,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 317.365 249.332)",
    fill: "url(#paint2_linear_439_972)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 36.1894,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 317.301 264.642)",
    fill: "url(#paint3_linear_439_972)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 11.1352,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 339.365 249.443)",
    fill: "url(#paint4_linear_439_972)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 20.8785,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 339.301 264.754)",
    fill: "url(#paint5_linear_439_972)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109 21.9998L56 21.9998",
    stroke: "url(#paint6_linear_439_972)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M537.498 22L590.498 22",
    stroke: "url(#paint7_linear_439_972)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.499 13.4999C115.499 9.83321 115.499 8.04172 115.499 4.84171C115.498 1.64171 112.832 1.17505 111.499 1.34172L55.9995 1.34172",
    stroke: "url(#paint8_linear_439_972)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M530.996 13.4999C530.996 9.83321 530.996 8.04172 530.996 4.84171C530.996 1.64171 533.663 1.17505 534.996 1.34172L590.495 1.34172",
    stroke: "url(#paint9_linear_439_972)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.999 192.842C62.799 199.642 59.1657 201.008 57.999 200.842L34.999 200.842H20",
    stroke: "url(#paint10_linear_439_972)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M568.497 192.842C573.697 199.642 577.331 201.008 578.497 200.842L601.497 200.842H616.496",
    stroke: "url(#paint11_linear_439_972)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4995 208L86.998 217.842C84.598 220.642 81.998 221.675 80.998 221.842H60.998H40.9995",
    stroke: "url(#paint12_linear_439_972)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60.998,
    y1: 220.842,
    x2: 60.998,
    y2: 226.842,
    stroke: "#BBBBBB",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 40.9995,
    y1: 220.842,
    x2: 40.9995,
    y2: 226.842,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M540.998 208L549.499 217.842C551.899 220.642 554.499 221.675 555.499 221.842H575.499H595.498",
    stroke: "url(#paint13_linear_439_972)",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 6,
    y2: -1,
    transform: "matrix(4.43579e-08 1 1 -4.37112e-08 576.499 220.842)",
    stroke: "#BBBBBB",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 6,
    y2: -1,
    transform: "matrix(4.43579e-08 1 1 -4.37112e-08 596.498 220.842)",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7906 308.231L71.7906 273.231C71.3605 272.321 68.8003 270.5 62.0003 270.5L57.4998 270.5",
    stroke: "url(#paint14_linear_439_972)",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M537.707 308.231L564.707 273.231C565.137 272.321 567.697 270.5 574.497 270.5L578.997 270.5",
    stroke: "url(#paint15_linear_439_972)",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.013 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.088 192.918)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.164 192.918)",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M575.236 193.664C575.238 193.252 575.574 192.918 575.986 192.918L584.312 192.918C585.417 192.918 586.307 193.813 586.301 194.918L586.298 195.549C586.292 196.568 585.461 197.394 584.442 197.394L578.945 197.394C576.884 197.394 575.224 195.724 575.236 193.664Z",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3062 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2305 192.918)",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1548 192.918)",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0749 193.664C61.0772 193.252 60.7451 192.918 60.333 192.918L52.0064 192.918C50.9018 192.918 50.0013 193.813 49.995 194.918L49.9914 195.549C49.9856 196.568 50.8072 197.394 51.8264 197.394L57.3234 197.394C59.3836 197.394 61.0632 195.724 61.0749 193.664Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_972",
    x1: 1.00001,
    y1: 11.1352,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_972",
    x1: 1.00001,
    y1: 20.8785,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_972",
    x1: 1.00001,
    y1: 19.4866,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_972",
    x1: 1.00001,
    y1: 36.1894,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_439_972",
    x1: 1.00001,
    y1: 11.1352,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_439_972",
    x1: 1.00001,
    y1: 20.8785,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_439_972",
    x1: 56,
    y1: 21.4998,
    x2: 109,
    y2: 21.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_439_972",
    x1: 590.498,
    y1: 21.5,
    x2: 537.498,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_439_972",
    x1: 118,
    y1: -10.5001,
    x2: 128.562,
    y2: 0.709077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_439_972",
    x1: 528.495,
    y1: -10.5001,
    x2: 517.932,
    y2: 0.709077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_439_972",
    x1: 22.5,
    y1: 208.5,
    x2: 48.4009,
    y2: 224.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_439_972",
    x1: 613.996,
    y1: 208.5,
    x2: 588.095,
    y2: 224.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_439_972",
    x1: 56.5,
    y1: 222,
    x2: 90.605,
    y2: 226.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_439_972",
    x1: 579.997,
    y1: 222,
    x2: 545.892,
    y2: 226.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_439_972",
    x1: 70.6026,
    y1: 274.147,
    x2: 97.6026,
    y2: 309.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_439_972",
    x1: 565.895,
    y1: 274.147,
    x2: 538.895,
    y2: 309.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame14);
export default __webpack_public_path__ + "static/media/card1-frame14.cf4db99bf03de7061266df3f4c5f60b4.svg";
export { ForwardRef as ReactComponent };